import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CheckPasswordDTO, SendMessageDTO } from './profile/account.dto';
import { environment } from '../../environments/environment';
import { PhoneNumberUtil } from 'google-libphonenumber';
@Injectable({ providedIn: 'root' })
export class AccountService {
  constructor(private http: HttpClient) {}
  sendMessage(body: SendMessageDTO) {
    const url = environment.apiUrl + '/api/account/contactus';
    return this.http.post(url, body);
  }

  checkPassword(credentials: CheckPasswordDTO) {
    const url = environment.apiUrl + '/api/account/checkpassword';
    return this.http.post<Boolean>(url, credentials);
  }

  checkPhoneNumber(number: string, countryCode: string) {
    const phoneUtil = PhoneNumberUtil.getInstance();
    try {
      const phoneNumber = phoneUtil.parseAndKeepRawInput(number, countryCode);
      return phoneUtil.isValidNumber(phoneNumber);
    } catch (error) {
      console.error('Invalid phone number format:', error);
      return false;
    }
  }
}
